import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { formatDate } from '@lib/shared';

export function dateBeforeValidator(compareControlName: string): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		const value = control.value;

		// Suche das compareControl in der gleichen Gruppe.
		const group = control.parent;

		if (!group) {
			return null;
		}

		const compareControl = group.get(compareControlName.replace(/^\./, ''));

		if (!compareControl) {
			return null;
		}

		const compareDate = compareControl.value;

		const begin = parseDateOrTime(value);
		const end = parseDateOrTime(compareDate);

		if (begin === null || end === null) {
			return null;
		}

		if (begin > end) {
			return { dateBefore: 'Das Datum muss vor dem ' + formatComparisonValue(compareDate) + ' liegen!' };
		}

		return null; // Gültig, wenn das Datum im angegebenen Jahr liegt
	};
}

function parseDateOrTime(value: unknown): number | null {
	const normalized = String(value ?? '').trim();
	const timeMatch = /^(\d{2}):(\d{2})(?::(\d{2}))?$/.exec(normalized);
	if (timeMatch) {
		const hours = Number(timeMatch[1]);
		const minutes = Number(timeMatch[2]);
		const seconds = Number(timeMatch[3] ?? 0);
		if (hours > 23 || minutes > 59 || seconds > 59) {
			return null;
		}
		return hours * 3600 + minutes * 60 + seconds;
	}

	const timestamp = Date.parse(normalized);
	return Number.isNaN(timestamp) ? null : timestamp;
}

function formatComparisonValue(value: unknown): string {
	const normalized = String(value ?? '').trim();
	return /^\d{2}:\d{2}(?::\d{2})?$/.test(normalized) ? normalized.slice(0, 5) : formatDate(new Date(normalized));
}
